import React, { useState } from 'react';
import { DiffEditor } from '@monaco-editor/react';

export const DiffView: React.FC = () => {
  const [original] = useState<string>('{\n  "name": "MamaJSON"\n}');
  const [modified] = useState<string>('{\n  "name": "MamaJSON",\n  "awesome": true\n}');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <h2 style={{ margin: 0 }}>JSON Diff (Comparator)</h2>
        <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Compare two JSON objects side-by-side to visually highlight additions, deletions, and modifications.</p>
      </div>
      <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
        <DiffEditor
          height="100%"
          language="json"
          original={original}
          modified={modified}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            renderSideBySide: true,
            scrollbar: { vertical: 'auto', horizontal: 'auto' },
            originalEditable: true
          }}
        />
      </div>
        </div>
    </div>
  );
};
